export default __webpack_public_path__ + "static/media/Big_Bash_App_Icon.aec4cc1c.png";